module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/coupons/Row.ejs -->\n<td class="td-nowrap">\n    <div class="form-control form-control-with-delete">\n        <span class="form-control-value"></span>\n\n        <input name="code"\n            class="form-control form-control-invisible"\n            type="text" autocomplete="off"\n            value="'+
((__t=( model.get('code') ))==null?'':_.escape(__t))+
'">\n\n        <a class="form-control-delete fa fa-times btn-delete js-destroy"\n            tabindex="-1"></a>\n    </div>\n\n    <div class="error error-code error-uses error-newCustomers"></div>\n    <div class="error error-code error-uses error-newCustomers\n        error-placeholder"></div>\n</td>\n\n<td class="form-group">\n    <input type="text" name="uses"\n        class="form-control form-control-invisible"\n        value="'+
((__t=( model.get('uses') ))==null?'':_.escape(__t))+
'">\n</td>\n\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="newCustomers"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('newCustomers') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n\n<td>'+
((__t=( model.get('createdAt') ))==null?'':_.escape(__t))+
'</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/coupons/Row.ejs
// module id = 689
// module chunks = 1